import { setLocalStorage, getLocalStorage } from "./GetSetStorage";
import { getWeather } from "./Weather";
const translate = document.querySelector(".translate");
const langEn = document.querySelector(".en");
const langRu = document.querySelector(".ru");
let langCurrent;
function translateEnRu() {
  translate.addEventListener("click", (e) => {
    if (e.target == langEn) {
      langCurrent = "en";
      langEn.classList.add("active");
      langRu.classList.remove("active");
      setLocalStorage("lang", langCurrent);
      langCurrent = getLocalStorage("lang");
      getWeather(langCurrent);
      setPlaceholderName(langCurrent);
      setPlaceholderCity(langCurrent);
      return langCurrent;
    } else if (e.target == langRu) {
      langCurrent = "ru";
      langRu.classList.add("active");
      langEn.classList.remove("active");
      setLocalStorage("lang", langCurrent);
      langCurrent = getLocalStorage("lang");
      getWeather(langCurrent);
      setPlaceholderName(langCurrent);
      setPlaceholderCity(langCurrent);
      return langCurrent;
    }
  });
}
translateEnRu();
const dictionary = {
  Ru: {
    Good_morning: "Доброе утро,",
    Good_afternoon: "Добрый день,",
    Good_evening: "Добрый вечер,",
    Good_night: "Доброй ночи,",
    Audio: "Плеер",
    Date: "Дата",
    English: "Английский",
    Enter_name: "Введите имя",
    Greeting: "Приветствие",
    Humidity: "Влажность воздуха",
    Language: "Язык",
    Photo_source: "Источник фото",
    Russian: "Русский",
    Settings: "Настройки",
    Tags: "Теги",
    Time: "Время",
    Quote: "Цитата",
    Weather: "Погода",
    Wind: "Ветер",
  },
  En: {
    Good_morning: "Good morning,",
    Good_afternoon: "Good afternoon,",
    Good_evening: "Good evening,",
    Good_night: "Good night,",
    Audio: "Audio",
    Date: "Date",
    English: "English",
    Enter_name: "Enter name",
    Greeting: "Greeting",
    Humidity: "Humidity",
    Language: " Language",
    Photo_source: "Photo_source",
    Russian: "Russian",
    Settings: "Settings",
    Tags: "Tags",
    Time: "Time",
    Quote: "Quote",
    Weather: "Weather",
    Wind: "Wind",
  },
};
function setPlaceholderName() {
  const name = document.querySelector(".name");
  if (langCurrent == "en") {
    name.placeholder = "Enter your name";
  } else if (langCurrent == "ru") {
    name.placeholder = "Введите ваше имя";
  }
}
function setPlaceholderCity() {
  const name = document.querySelector(".name");
  let cityInput = document.querySelector(".city");
  if (langCurrent == "en") {
    cityInput.placeholder = "Enter city";
  } else if (langCurrent == "en") {
    cityInput.placeholder = "Введите город";
  }
}

export {
  translateEnRu,
  setPlaceholderName,
  setPlaceholderCity,
  langCurrent,
  dictionary,
};
